import React from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";

export const ReportFilterBar = ({ filters, onFilterChange, onExport, loading }) => {
  return (
    <Card className="shadow-sm border-0 mb-4 pb-0">
      <Card.Body className="pb-3 pt-3">
        <Row className="g-3 align-items-end">
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small fw-semibold text-muted mb-1">From Date</Form.Label>
              <Form.Control
                type="date"
                value={filters.startDate}
                onChange={(e) => onFilterChange({ startDate: e.target.value })}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small fw-semibold text-muted mb-1">To Date</Form.Label>
              <Form.Control
                type="date"
                value={filters.endDate}
                onChange={(e) => onFilterChange({ endDate: e.target.value })}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={4}>
            <Form.Group>
              <Form.Label className="small fw-semibold text-muted mb-1">Service Type</Form.Label>
              <Form.Select
                value={filters.service}
                onChange={(e) => onFilterChange({ service: e.target.value })}
              >
                <option value="">All Services</option>
                <option value="recharge">Mobile Recharge</option>
                <option value="dth">DTH Recharge</option>
                <option value="bbps">BBPS</option>
                <option value="aeps">AEPS</option>
                <option value="dmt">DMT</option>
                <option value="matm">MATM</option>
                <option value="fund_transfer">Fund Transfer</option>
                <option value="credit_debit">Credit / Debit</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={2} className="text-md-end">
            <Button variant="secondary" onClick={onExport} className="w-100 fw-semibold text-nowrap d-flex align-items-center justify-content-center">
              <i className="ph-duotone ph-download-simple me-2"></i> Export CSV
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
